<template>
  <div class="month-year-input-container mb-3">
    <label>
      <question-display :question="question"  customClass="header-monthyear"></question-display>
    </label>
    <div class="row">
      <div class="col-md-6">
        <select v-model="inputValue.month" class="form-control form-select">
          <option value="Don't Know">Don't Know</option>
          <option v-for="month in filteredMonths" :key="month" :value="month">{{ month }}</option>
          
        </select>
      </div>
      <div class="col-md-6">
        <select v-model="inputValue.year" class="form-control form-select">
          <option value="Don't Know" >Don't Know</option>
          <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
         
        </select>
      </div>
    </div>
    <small v-if="showValidation && question.required && (!inputValue.month || !inputValue.year)" class="text-danger">This field is required.</small>
  </div>
</template>

<script>
import surveyService from '@/services/surveyService'; // Import the survey service
import QuestionDisplay from '../utils/QuestionDisplay.vue';

export default {
  components: {
      QuestionDisplay
  },
  props: {
    question: Object,
    showValidation: Boolean // Add showValidation prop
  },
  data() {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const years = this.generateYears();
    const currentYear = new Date().getFullYear();
    
    // Set different default values based on question ID
    const defaultYear = this.question.id === '12.c' ? currentYear.toString() : `Current year (${currentYear})`;

    return {
      inputValue: surveyService.getAnswer(this.question.id) || { month: months[new Date().getMonth()], year: defaultYear },
      months,
      years
    };
  },
  computed: {
    filteredMonths() {
      const currentMonthIndex = new Date().getMonth();
      const currentYear = new Date().getFullYear();
      if (this.inputValue.year === "Don't Know") {
        return this.months;
      }
      return this.inputValue.year === currentYear 
        ? this.months.slice(0, currentMonthIndex + 1) 
        : this.months;
    }
  },
  methods: {
    updateInput() {
      surveyService.setAnswer(this.question.id, this.inputValue); // Save the answer directly through the service
      this.$emit('input', this.inputValue);
    },
    generateYears() {
      const currentYear = new Date().getFullYear();
      const years = [];
      let incr = 0;
      
      for (let i = currentYear; i >= currentYear - 3; i--) {
        if (this.question.id === '12.c') {
          // For Q12c, show only the year without "Current year - #" format
          years.push(i.toString());
        } else {
          // For other questions, keep the original format
          if (incr == 0) {
            years.push(`Current year (${i})`);
          } else {
            years.push(`Current year - ${incr} (${i})`);
          }
        }
        incr++;
      }
      return years;
    }
  },
  watch: {
    inputValue: {
      handler() {
        this.updateInput();
      },
      deep: true
    },
    question(newQuestion) {
      const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      this.inputValue = surveyService.getAnswer(newQuestion.id) || { month: months[new Date().getMonth()], year: new Date().getFullYear() };
    }
  }
};
</script>

<style scoped>
.month-year-input-container {
  display: flex;
  flex-direction: column;
}
</style>
